// ارتباط با سرور برای ورود / ثبت‌نام. ورود با کوکیِ httpOnly نگه داشته می‌شود (نه localStorage).
// هر خطا یک Error با message فارسی (قابلِ نشان دادن به کاربر) و code است.

async function call(path, body) {
  let resp;
  try {
    resp = await fetch(`/api/auth/${path}`, {
      method: body ? 'POST' : 'GET',
      credentials: 'same-origin',
      headers: body ? { 'Content-Type': 'application/json' } : undefined,
      body: body ? JSON.stringify(body) : undefined,
    });
  } catch (e) {
    const err = new Error('اتصال به سرور برقرار نشد؛ اینترنت را بررسی کنید.');
    err.code = 'network';
    throw err;
  }
  let data = {};
  try {
    data = await resp.json();
  } catch (e) {
    /* پاسخِ غیرِ JSON */
  }
  if (!resp.ok) {
    const err = new Error(data.message || 'خطایی پیش آمد؛ دوباره امتحان کنید.');
    err.code = data.error || `http-${resp.status}`;
    err.data = data;
    throw err;
  }
  return data;
}

export const sendCode = (phone) => call('send-code', { phone });
export const verifyCode = (phone, code) => call('verify', { phone, code });
export const register = (signupToken, firstName, lastName, role) =>
  call('register', { signupToken, firstName, lastName, role });
export const logout = () => call('logout', {});

// کاربرِ واردشده یا null
export async function fetchMe() {
  try {
    const { user } = await call('me');
    return user || null;
  } catch (e) {
    if (e.code === 'not-logged-in') return null;
    throw e;
  }
}

// ویرایشِ پروفایل: { firstName?, lastName?, bio? } → user
export const updateProfile = (patch) =>
  fetch('/api/auth/me', {
    method: 'PATCH',
    credentials: 'same-origin',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(patch),
  })
    .catch(() => {
      const err = new Error('اتصال به سرور برقرار نشد؛ اینترنت را بررسی کنید.');
      err.code = 'network';
      throw err;
    })
    .then(async (resp) => {
      const data = await resp.json().catch(() => ({}));
      if (!resp.ok) {
        const err = new Error(data.message || 'ذخیره نشد؛ دوباره امتحان کنید.');
        err.code = data.error;
        throw err;
      }
      return data.user;
    });
